import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AmlSanctionsComponent } from './aml-sanctions.component';
 

const routes: Routes = [
  { path: '', component: AmlSanctionsComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AmlSanctionsRoutingModule { }
